import React from 'react';
import { Col, Select } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useGetOrganizations } from '@/hooks/v1';
import type { InputDefaultProps } from '../../../types';
import { FormItem } from '@/components/ui/Inputs/FormItem';

export function Organization({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	const { data: organizations } = useGetOrganizations();

	const options = organizations?.map((organization) => {
		return {
			label: organization?.name,
			value: organization?.id
		};
	});

	return (
		<Col span={24}>
			<FormItem
				fontSize={fontSize}
				isRequired={isRequired}
				title={I18n.get('Company')}
				namePath={[fieldName, 'organization_id']}
			>
				<Select size="large" disabled={disabled} options={options} />
			</FormItem>
		</Col>
	);
}
